import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import { Email, HttpResponse } from "@/types";

export function useGetEmails({ talentId }: { talentId: number | null }) {
  return useQuery({
    queryKey: ["emails", talentId],
    refetchInterval: 10_000,
    queryFn: async () => {
      const queryParams = misc.prepareQueryParams({ talentId });

      // Need to query with talentId.
      if (queryParams.toString() === "") return [];

      const path = `emails?${queryParams.toString()}`;
      const res = await guacHttpClient.get<Email[], HttpResponse<Email[]>>(
        path,
      );
      return res.data;
    },
  });
}
